import { useContext } from 'react';
import { AxiosContext } from '../context/axios-context';

export function useAxios() {
    return useContext(AxiosContext);
}
